import React, { useState } from "react";
import { Button } from "react-blueprint-library";
import { useOktaAuth } from "@okta/okta-react";
import { updateContractStatus } from "../../../../api/makeAPIRequest";
import {
  CONTRACT_STATUS_ID,
  CONTRACT_TYPE_DESCRIPTIONS,
} from "../../../../constants/Contract";
import { addOnBuilder } from "../../../../common/Functions";
import { sentToCandidateListItems } from "../../../../constants/sentToCandidate";
import STCCheckListItem from "./STCCheckListItem";

const SentToCandidatePage = ({
  contractid = "",
  nyregs = "",
  contract = "",
  agencynumber = "",
  multiContracts = 0,
  archiveContract = 0,
  mmlis = false,
  financingonly = false,
  cria = false,
  ia = false,
  toggleGetStarted = () => {},
}) => {
  const { authState } = useOktaAuth();
  const [isLoading, setIsLoading] = useState(false);

  const { sub: oktasubid = "", email = "" } = authState?.idToken?.claims;

  const getStartedClick = async () => {
    setIsLoading(true);
    await updateContractStatus(
      oktasubid,
      contractid,
      email,
      CONTRACT_STATUS_ID.APPLICATION_IN_PROGRESS,
    );
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    await delay(750);
    //redirects to application page
    window.location = `/startapplication?contract=${contractid}`;
  };

  const dashboardClick = async () => {
    toggleGetStarted();
  };
  const processText = (text = "", nyregs = false) => {
    if (nyregs) {
      text = text.replaceAll("sales", "production").replaceAll("PSR", "PPR");
    }
    return text;
  };

  const processSubItems = (subItems = [], nyregs = false) => {
    return subItems.map((subItem, index) => {
      const newSubItem = nyregs
        ? subItem
            .replaceAll("commissions", "production")
            .replaceAll("PSR", "PPR")
        : subItem;
      return <li key={index}>{newSubItem}</li>;
    });
  };

  const renderCheckListItems = (items, contract, nyregs) => {
    return items.map((item, key) => {
      let text =
        typeof item === "string"
          ? processText(item, nyregs)
          : processText(item[0], nyregs);

      let subList = [];
      if (typeof item === "object") {
        subList = processSubItems(item[1], nyregs);
      }

      return (
        <STCCheckListItem id={key} item={text} key={key}>
          {subList.length > 0 && (
            <ul>
              {subList.map((subItem, subKey) => (
                <li key={subKey}>{subItem}</li>
              ))}
            </ul>
          )}
        </STCCheckListItem>
      );
    });
  };
  const getCheckList = () => {
    let listItems = [];
    let textToDisplay = [];

    if (contract === CONTRACT_TYPE_DESCRIPTIONS.INDIVIDUAL_BROKER) {
      textToDisplay = sentToCandidateListItems.INDIVIDUAL_BROKER;
    } else if (contract === CONTRACT_TYPE_DESCRIPTIONS.BROKER_CORP) {
      textToDisplay = sentToCandidateListItems.BROKER_CORP;
    } else if (contract === CONTRACT_TYPE_DESCRIPTIONS.MEMBER_CORP) {
      textToDisplay = sentToCandidateListItems.MEMBER_CORP;
    } else if (contract === CONTRACT_TYPE_DESCRIPTIONS.CAREER_AGENT) {
      textToDisplay = sentToCandidateListItems.CAREER_AGENT;
    } else if (contract === CONTRACT_TYPE_DESCRIPTIONS.CAREER_SAMPLING) {
      textToDisplay = sentToCandidateListItems.CAREER_SAMPLING;
    } else if (contract === CONTRACT_TYPE_DESCRIPTIONS.ALTERNATE_AGENT) {
      textToDisplay = sentToCandidateListItems.ALTERNATE_AGENT;
    } else if (contract === CONTRACT_TYPE_DESCRIPTIONS.COLLEGE_INTERN) {
      textToDisplay = sentToCandidateListItems.COLLEGE_INTERN;
    } else if (contract === CONTRACT_TYPE_DESCRIPTIONS.FINANCING_ONLY) {
      textToDisplay = sentToCandidateListItems.FINANCING_ONLY;
    } else if (contract === CONTRACT_TYPE_DESCRIPTIONS.MMLIS) {
      textToDisplay = sentToCandidateListItems.MMLIS;
    } else if (contract === CONTRACT_TYPE_DESCRIPTIONS.PRELIMINARY) {
      textToDisplay = sentToCandidateListItems.PRELIMINARY;
    } else if (contract === CONTRACT_TYPE_DESCRIPTIONS.AGENT_EMERITUS) {
      textToDisplay = sentToCandidateListItems.AGENT_EMERITUS;
    } else if (contract === CONTRACT_TYPE_DESCRIPTIONS.RETIRED_BROKER) {
      textToDisplay = sentToCandidateListItems.RETIRED_BROKER;
    } else if (
      contract === CONTRACT_TYPE_DESCRIPTIONS.CRIA_ONLY ||
      contract === CONTRACT_TYPE_DESCRIPTIONS.INVESTMENT_ADVISOR
    ) {
      textToDisplay = sentToCandidateListItems.CRIA_ONLY;
    }

    listItems = renderCheckListItems(textToDisplay, contract, nyregs);
    return listItems;
  };
  return (
    <div id="sentToCandidate">
      <div className="row">
        <div className="col-md-9" id="welcome-message">
          <h3 id="welcome-message-text">
            Welcome to MassMutual. You have been invited to complete the
            following application - {contract}
            {addOnBuilder(mmlis, financingonly, cria, ia)} with Agency #
            {agencynumber}
          </h3>
          <h4 id="askd-apltn">In the application you'll be asked to:</h4>
        </div>
      </div>
      {contract === CONTRACT_TYPE_DESCRIPTIONS.INDIVIDUAL_BROKER && (
        <div className="row">
          <div className="col-md-12">
            <div className="copy-md mm-spacing--minor" id="get-started-text">
              Once you get started, your progress will be saved as you move
              through the pages and you will be able to return to complete your
              application where you left off.
            </div>
          </div>
        </div>
      )}
      <div className="row mm-spacing--minor">
        <div className="col-md-7">
          <ul id="checkList" className="list-unstyled">
            {getCheckList()}
          </ul>
        </div>
      </div>

      <div id="sentToCandidateNavWrapper" className="row mm-spacing--minor">
        <div className="col-sm-12 col-md-6 col-lg-5">
          {(multiContracts > 1 || archiveContract > 0) && (
            <Button
              id="returnToDashboardBtn"
              variant="inline"
              onClick={dashboardClick}
              style={{
                marginTop: ".6rem",
                marginBottom: ".6rem",
              }}
            >
              <span className="icon-caret-alt-spin-left"></span>
              <strong id="rtn-to-dashboard-link">Back to Dashboard</strong>
            </Button>
          )}
          <button
            id="getstarted-button"
            type="button"
            className={`btn ${isLoading ? "btn-primary-loading" : "btn-primary"}`}
            onClick={getStartedClick}
            disabled={isLoading}
          >
            {!isLoading ? <>Get Started</> : <></>}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SentToCandidatePage;
